const React = require("react");

const TitledMessage = require("./TitledMessage.jsx");

const EmptyList = React.createClass({
    render() {
        const style = Object.assign({}, this.props.style, {
            fontSize: 42,
            textAlign: "center",
            color: "#bbb",
            lineHeight: 1.8
        });

        return (<TitledMessage style={style}
                               Title="Want to upload some files?"
                               Subtitle="Drop them here." />);
    }
});

module.exports = EmptyList;


// WEBPACK FOOTER //
// ./src/components/EmptyList.jsx